export const TEST_ID = 'navigationLink';
